<template>
  <v-content class="">
    <section>
      <v-parallax
        :src="require('@/assets/beach-tsv2.jpg')"
        height="500"
        class="banner"
      >
        <Navbar></Navbar>

        <v-layout column class="white--text " justify-end>
          <div>
            <v-container justify-end>
              <div class=" display-1  mt-3 subpage-heading-1 ">
                Learn about wind-driven rain damage to buildings
              </div>
              <div class=" headline  mt-3 subpage-heading-2 ">
                General information about wind-driven rain damage
              </div>
            </v-container>
          </div>
        </v-layout>
      </v-parallax>
    </section>

    <section>
      <v-container class=" white-background">
        <v-breadcrumbs divider=">">
          <v-breadcrumbs-item @click="gotoDamage">Damage</v-breadcrumbs-item>
          <v-breadcrumbs-item @click=""> > </v-breadcrumbs-item>
          <v-breadcrumbs-item @click="gotoRain"
            >Wind Driven Rain</v-breadcrumbs-item
          >
        </v-breadcrumbs>
        <v-layout column wrap class="" align-center>
          <v-flex xs12 class="my-3">
            <div class="text-xs-center">
              <h2 class="headline pa-2">Wind-Driven Rain Damage</h2>
              <span class="subheading pa-2"> General Information</span>
            </div>
            <div>
              <p class="pl-2 pr-2 pt-2">
                Significant amounts of wind-driven rain can enter buildings,
                even during cyclones with winds significantly less than the
                design wind speed, and even if there is no structural damage
                such as roof loss.
              </p>

              <p class="pl-2 pr-2 pt-2">
                In previous cyclones, significant volumes of water have entered
                the windward side of undamaged houses:
              </p>

              <ul>
                <li>
                  through weep holes in windows and glass door frames
                </li>
                <li>
                  through poor quality or damaged seals
                </li>
                <li>
                  through windows or glass sliding doors with flexible sashes
                </li>
                <li>
                  around flexible, inward opening swinging doors
                </li>
                <li>
                  up valley gutters
                </li>
                <li>
                  through damaged flashings or under inadequately secured
                  flashings.
                </li>
              </ul>
            </div>
            <p class="pl-2 pr-2 pt-2">
              <v-btn text outlined href="https://www.jcu.edu.au/cyclone-testing-station/education/resources">
              Videos of wind driven rain damage</v-btn>

            </p>
          </v-flex>
          <v-flex style=" width: 100%">
            <v-carousel style="height: auto; width: 100%" :cycle="cycle" dark>
              <v-carousel-item
                v-for="(item, i) in rainItems"
                :src="item.name"
                :key="i"
              >
                <v-responsive dark>
                  <v-container fill-height>
                    <v-layout align-center>
                      <v-flex aling-start justify-center>
                        <h3 class="display-1 white--text">
                          {{ item.heading }}
                        </h3>
                        <span class="subheading white--text font-weight-bold">{{
                          item.text
                        }}</span>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-responsive>
              </v-carousel-item>
            </v-carousel>
          </v-flex>
        </v-layout>
      </v-container>
    </section>
    <Footer></Footer>
  </v-content>
</template>

<style>
  .v-breadcrumbs__item{
    color: #1976D2;
    cursor: pointer;
  }
</style>

<script>
import Navbar from "./Navbar.vue";
import Footer from "./Footer.vue";
import { router } from "../router";

import image1 from "../assets/1_rain.jpg";
import image2 from "../assets/18_rain.jpg";
import image3 from "../assets/19_rain.jpg";
import image4 from "../assets/20_rain.jpg";
import image5 from "../assets/21_rain.jpg";
import image6 from "../assets/21_rain_1.jpg";
import image7 from "../assets/22_rain.jpg";
import image8 from "../assets/23_rain.jpg";
import image9 from "../assets/24_rain.jpg";
import image10 from "../assets/rain-1.jpg";

export default {
  name: "Wind",
  components: {
    Navbar,
    Footer
  },
  data: () => ({
    size: "sm",
    cycle: false,
    rainItems: [
      {
        name: image3,
        heading: "Ceiling Damage",
        text: "Water entered ceiling space and plasterboard ceilings collapsed"
      },
      {
        name: image1,
        heading: "Ceiling Damage",
        text: "Water entered ceiling space and plasterboard ceilings collapsed"
      },
      {
        name: image2,
        heading: "Ceiling Damage",
        text: "Water entered ceiling space and plasterboard ceilings collapsed"
      },
      {
        name: image4,
        heading: "Ceiling Damage",
        text:
          "Mould on ceilings caused by wind-driven rain entering the roof space"
      },
      {
        name: image5,
        heading: "Floor Damage",
        text: "Water damage to timber overlay floors"
      },
      {
        name: image6,
        heading: "Ceiling Damage",
        text:
          "Mould on ceilings caused by wind-driven rain entering the roof space"
      },
      {
        name: image7,
        heading: "Window Damage",
        text: "Water bubbling up through weep holes "
      }
    ]
  }),
  methods: {
    gotoDamage() {
      router.push("/damage");
    },
    gotoRain() {
      router.push("/rain");
    }
  }
};
</script>
